import { SelectInputData } from "@src/components/deprecated/SelectInputField/SelectInputField";
import { isEqual } from "lodash";
import { UnitData } from "to-be-removed/LocalData/Property/Units/UnitData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { InputElementContext } from "../DataObjectField";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataUnitField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<UnitData, FirebaseDataType> {
  override encode = (value: UnitData) => value.id;

  equalComparator = (a: UnitData | UnitData[] | undefined, b: UnitData | UnitData[] | undefined) => {
    return isEqual(a, b);
  };

  override convertValueToSelectInput(value: UnitData): SelectInputData {
    return new SelectInputData(value.id, value.name);
  }
  getValueForKey(key: string): UnitData | undefined {
    return LocalData.getUnitWithId(key);
  }
  getOptions(context?: InputElementContext): FirebaseDataSelectFieldOption[] {
    return (context?.propertyID ? (LocalData.properties.getData(context.propertyID)?.units ?? []) : LocalData.units)
      .filter((unit) => unit.loaded && !unit.deleted && !unit.parent?.deleted)
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      .map((unit) => {
        return { key: unit.id, label: unit.name };
      });
  }
  getReadableStringRepresentation(value: UnitData): string {
    return value.name;
  }

  loadAllDatas(context?: InputElementContext | undefined): Promise<void> {
    const property = context?.propertyID ? LocalData.properties.getData(context.propertyID) : undefined;
    if (property && !property.unitsLoaded) {
      return new Promise((resolve) => property?.loadUnits(() => resolve()));
    }
    return Promise.resolve();
  }
  loadData(value: UnitData): Promise<any> {
    if (!value.loaded) {
      return value.load();
    } else {
      return Promise.resolve();
    }
  }
  override isValueValid = (value: any): boolean => {
    return value instanceof UnitData;
  };
}
